import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import parlour from "../../assets/img/cart/parlour.PNG";
import cart1 from "../../assets/img/cart/cart1.JPEG";
import cart2 from "../../assets/img/cart/cart2.JPEG";
import cart3 from "../../assets/img/cart/cart3.JPEG";
import cart4 from "../../assets/img/cart/cart4.JPEG";
import cart5 from "../../assets/img/cart/IMG_0041.JPEG";
import cart6 from "../../assets/img/cart/cart6.JPEG";
import cart7 from "../../assets/img/cart/cart7.JPEG";
import cart8 from "../../assets/img/cart/cart8.JPEG";
import cart9 from "../../assets/img/cart/cart9.JPEG";
import cart10 from "../../assets/img/cart/cart10.JPEG";
import rickshaw from "../../assets/img/cart/IMG_0248.PNG";
import hutShapePow from "../../assets/img/cart/hutshapepow.PNG";
import icecreamcounter from "../../assets/img/cart/icecreamcounter.PNG";
import alloywheel from "../../assets/img/cart/cart3.JPEG";
import halfCircle from "../../assets/img/cart/IMG_0054.JPEG";

import sqrPipe from "../../assets/img/cart/cart7.JPEG";
import traditionalCanopy from "../../assets/img/cart/IMG_0063.JPEG";
import canpushcart from "../../assets/img/cart/IMG_0065.JPEG";

import smallE from "../../assets/img/cart/IMG_0128.PNG";
import bigE from "../../assets/img/cart/IMG_0133.PNG";
import shavedIceE from "../../assets/img/cart/IMG_0145.PNG";
import hatShapeE from "../../assets/img/cart/IMG_0136.PNG";
import billBoardE from "../../assets/img/cart/IMG_0146.PNG";
import hiEnergy from "../../assets/img/cart/IMG_0127.PNG";
import energyMax from "../../assets/img/cart/IMG_0129.PNG";
import bbq from "../../assets/img/cart/IMG_0095.PNG";
import lampBell from "../../assets/img/cart/bell.jpeg";
import creamBell from "../../assets/img/cart/creamBellYellow.jpeg";
import popColla from "../../assets/img/cart/popCola.jpeg";
import fandb from "../../assets/img/cart/thirsty.jpeg";

import { useLocation, useNavigate } from "react-router-dom";
import Aos from "aos";
import SEO from "../Common/SEO";

// const workItems = [
//   {
//     image: cart1,
//     category: "Web Design",
//     title: "PARLOUR ON WHEELS",
//   },
//   {
//     image: cart2,
//     title: "Working Spaces for Startups Freelancer",
//   },
//   {
//     image: cart3,
//     title: "TRICYLE CARTS/ PUSH CART",
//   },
//   {
//     image: cart4,
//     title: "E-CARTS / E RCIKSHAW",
//   },
//   {
//     image: cart5,
//     category: "Web Design",
//     title: "Working Spaces for Startups Freelancer",
//   },
// ];
const workItems = {
  1: [
    {
      image: parlour,
      title: "PARLOUR ON WHEELS",
      link: "/parlour-on-wheels",
      desc: "For this category, only a deep freezer with a glass top is required. The remaining items will be provided by Cart Studio.",
    },

    {
      image: cart5,
      title: "TRICYLE CARTS/ PUSH CART",
      link: "/tricycle-carts",
      desc: "In the category of freezer transportation solutions, these products are designed to accommodate and safely move 120-liter to 200-liter freezers equipped with wheels.",
    },
    {
      image: rickshaw,
      title: "E-CARTS / E RCIKSHAW",
      link: "/e-carts",
      desc: "With the realm of electric transportation options, these carts are specifically designed to cover distances of up to 100 kilometers while accommoda ng storage capaci es ranging",
    },
  ],
  2: [
    {
      image: parlour,
      title: "Parlor on wheels",
      desc: "This parlor unit is equipped with a water tap and offers a customizable design. It can be tailored to accommodate glass-top deep freezers with a storage capacity ranging from 250 to 500 liters.",
    },
    {
      image: bbq,
      title: "BBQ Cart/Counter",
      desc: "This is a BBQ Cart designed as a functional counter for Grilling and Serving food. Perfect for outdoor cooking setups it combines utility with a sleek design.",
    },
    {
      image: hutShapePow,
      title: "Hut Shape Pow",
    },
    {
      image: cart2,
      title: "Pow With 2 Front Wheels",
    },
    {
      image: icecreamcounter,
      title: "Ice Cream Counter",
    },
  ],
  3: [
    {
      image: lampBell,
      title: "Lamp And Bell Cart",
      desc: " These versatile carts are designed to accommodate either 110-liter or 200-liter FOW, providing a convenient and efficient solution for moving these appliances.",
    },
    {
      image: halfCircle,
      title: "Half Circle Canopy (extra Long 66* Canopy)",
      desc: " These versatile carts are designed to accommodate either 110-liter or 200-liter FOW, providing a convenient and efficient solution for moving these appliances.",
    },
    {
      image: alloywheel,
      title: "Alloy Wheel Cart",
      desc: " These versatile carts are designed to accommodate either 110-liter or 200-liter FOW, providing a convenient and efficient solution for moving these appliances. Also has tube less tyre and drum breaks.",
    },
    {
      image: sqrPipe,
      title: "Sqr Pipe Dlx Cart",
      desc: "These versatile carts are designed to accommodate either 110-liter or 200-liter FOW, providing a convenient and efficient solution for moving these appliances.",
    },
    {
      image: traditionalCanopy,
      title: "Traditional 54* Canopy Cart",
      desc: "These versatile carts are designed to accommodate either 110-liter or 200-liter FOW, providing a convenient and efficient solution for moving these appliances.",
    },
    {
      image: creamBell,
      title: "Aero Dynamic Alloy Cart",
      desc: "These versatile carts are designed to accommodate either 110-liter or 200-liter FOW, providing a convenient and efficient solution for moving these appliances.",
    },
    {
      image: cart7,
      title: "5 Wheel Ice Cream Cart",
      desc: " These versatile carts are designed to accommodate either 120-liter or 200-liter FOW, providing a convenient and efficient solution for moving these appliances.",
    },
    {
      image: popColla,
      title: "Ice Lolly Small",
    },
    {
      image: canpushcart,
      title: "CAN Push Cart",
      desc: "For So Drink",
    },
    {
      image: fandb,
      title: "F&B Push Cart",
    },
    {
      image: cart6,
      title: "Shaved Ice",
    },
    {
      image: cart8,
      title: "Beverage Push Cart",
    },
  ],
  4: [
    {
      image: smallE,
      title: "Small E Cart",
      desc: "This product is an electric-powered cart designed to transport a 200-liter FOWr efficiently over distances ranging from 20 to 100 kilometers.",
    },
    {
      image: bigE,
      title: "Big E Cart With Double Canopy",
      desc: "This electric cart is designed to efficiently transport freezers of FOW sizes, including 200-liter, 275-liter, 300 liter, and 400-liter models.",
    },
    {
      image: shavedIceE,
      title: "Shaved Ice Cream E-cart",
      desc: "This mobile food cart is equipped with an electric motor and a 200-liter freezer, making it ideal for serving shaved ice and golas (Indian ice syrup desserts). Includes Shaved Ice Cream Machine",
    },
    {
      image: hatShapeE,
      title: "Hat Shape Canopy E Cart",
      desc: "This electric cart is designed to efficiently transport FOW sizes, including 200-liter, 275-liter.",
    },
    {
      image: billBoardE,
      title: "E Cart With Side Billboard",
      desc: "This electric cart is designed to efficiently transport FOW sizes, including 200-liter X 2.",
    },
    {
      image: cart2,
      title: "Cart With Umberbella",
      desc: "This product is designed to transport and accommodate 20-200 liter FOW effec vely over distances ranging from 20 to 40 kilometers.",
    },
    // {
    //   image: cart4,
    //   title: "E Cart With Hat",
    // },
    {
      image: hiEnergy,
      title: "Hi Energy Loader",
      desc: " This device is designed to efficiently recharge motorcycle batteries and has a of 80 liters FOW.. It offers a reliable and powerful solution for maintaining optimal battery performance",
    },
    {
      image: energyMax,
      title: "Energy Max Loader",
      desc: "This is a Cargo vehicle, can hold load upto 250-500 Kgs.",
    },
  ],
};

const ProductCarousel = ({ id, title }) => {
  const location = useLocation();
  let name = location?.pathname.replace(/\//g, "").replace(/-/g, " ");
  console.log("location", name);
  const navigate = useNavigate();

  useEffect(() => {
    Aos.init({
      duration: 800,
      once: true,
    });
    Aos.refresh(); // Ensure new elements are animated
  }, [id, location?.pathname]); //

  return (
    <div key={id} className="border  " data-aos="fade-up" data-aos-delay="100">
      <SEO 
        title={`${title} | Custom Cart Collection`}
        description={`Explore our premium collection of ${title}. High-quality, durable, and custom-manufactured mobility solutions for your business.`}
      />
      <div className="mt-4 py-[50px] lg:py-[60px]">
        {/* Attractive Header */}
        <div className="text-center mb-12" data-aos="fade-up">
           <span className="subtitle block mb-2 text-sm uppercase tracking-widest text-[#c85716] font-semibold">Premium Collection</span>
           <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 capitalize">{title}</h1>
           <div className="w-20 h-1 bg-[#c85716] mx-auto rounded-full mt-2"></div>
        </div>

        <div className="container py-1">
          <div className="row g-4">
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 pb-4">
              {workItems[id]?.length > 0 ? (
                workItems[id].map((card, index) => (
                  <div
                    onClick={() => card?.link && navigate(card?.link)}
                    className="col group cursor-pointer"
                    key={index}
                  >
                    <div className="card h-100 border-0 shadow-sm overflow-hidden transition-all duration-300 transform hover:-translate-y-2 hover:shadow-xl rounded-2xl bg-white">
                      <div
                        className="position-relative overflow-hidden bg-white"
                        style={{ height: "380px" }}
                      >
                        <img
                          src={card.image}
                          className="w-full h-full object-contain p-4 transition-transform duration-500 group-hover:scale-110"
                          alt={card.title}
                        />

                        {/* Title Overlay at bottom */}
                        <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-gray-900 via-gray-900/80 to-transparent pt-12 pb-6 px-4">
                          <h5 className="text-white text-center text-lg font-bold tracking-wide uppercase mb-0">
                            {card.title}
                          </h5>
                        </div>

                        <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center pb-16">
                          <span className="bg-white/20 backdrop-blur-md text-white px-6 py-2 rounded-full border border-white/30 font-medium">Explore</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col text-center  py-5 w-100 border border-gray-300 font-bold">
                  <p>No data found.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCarousel;
